import React from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import Icon from "../Icon";

/**
 * InputOrderFormSelect for any form.
 */


class InputOrderFormSelect extends React.Component {
	constructor(props) {
	    super(props);
	    this.onFocus = this.onFocus.bind(this);
	    this.onChange = this.onChange.bind(this);
	    this.doVerify = this.doVerify.bind(this);
	    this.state = {isFocused: false, isFilled: false, hasError: false, errorMsg:'', value:''};
	}
	componentDidMount() {
		if(this.props.value!=='') {
			this.fieldInput.value = this.props.value;
			this.setState({value: this.props.value});
		}
		if(this.fieldInput.value!=='') {
			this.setState({isFilled: true});
		}
	}
	onFocus(e) {
		this.setState({isFocused: true});
	}
	onChange(e) {
		this.setState({isFocused: false, value:this.fieldInput.value});
		if(this.fieldInput.value!=='') {
			this.setState({isFilled: true});
		}
		this.doVerify();
	}
	doVerify() {
		var hasError = false, errorMsg = '';
		if(this.props.required && this.fieldInput.value==='') {
			hasError = true;
			errorMsg = 'Dieses Feld wird benötigt.';
		}
		this.setState({hasError: hasError, errorMsg: errorMsg});

		this.props.onChange(this.fieldInput, hasError, this.props.itemkey);
	}
    render () {
    	const id = uniqueId('input_'); 
		const classNames = (this.state.isFocused?"focused ":"")+(this.state.isFilled?"filled ":"")+(this.state.hasError?"error ":"")+"inputfield inputselect"
		return (
			<div className={classNames}>
				<Icon filename="small_caret_down" size="15px" />
				<select id={id} onFocus={this.onFocus} onChange={this.onChange} name={this.props.name} ref={(input) => { this.fieldInput = input; }} value={this.state.value}>
				 	<option value="" disabled>{this.state.isFocused || this.state.isFilled?"Bitte wählen":""}</option>
				  {
				  	this.props.options.length?
				  	this.props.options.map((itm, n) => <option value={itm.value} key={`opt_${n}`}>{itm.label}</option>)
				  	:null
				  }
				</select>
				<label htmlFor={id}>{this.props.label}{this.props.required?"*":""}</label>
				{this.state.hasError && this.state.errorMsg!==''?<div className="errormsg">{this.state.errorMsg}</div>:null}
			</div>
		)
    }

}
InputOrderFormSelect.propTypes = {
	/** InputOrderFormSelect required */
	required: PropTypes.bool,
	/** InputOrderFormSelect options */
	options: PropTypes.array,
	/** InputOrderFormSelect value */
	value: PropTypes.string,
	/** InputOrderFormSelect value */
	itemkey: PropTypes.string,
	/** InputOrderFormSelect Label */
	label: PropTypes.string.isRequired,
}


InputOrderFormSelect.defaultProps = {
  required: false,
  value:'',
  itemkey:'',
  options:[]
}

export default InputOrderFormSelect;


// WEBPACK FOOTER //
// ./src/components/atoms/InputOrderFormElements/InputOrderFormSelect.js